module.exports = __webpack_public_path__ + "img/project_default_cover.af774e7d.png";